// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"6863": "454c9f289029","7357": "e05067d9e345","8357": "dd422574e14d","8561": "f9cad78a6d35","8990": "7d69c8cdd354",}[chunkId] + ".css"
}